module.exports = __webpack_public_path__ + "media/images/sp/stores/shibuya/shibuya_sns_05-24c119b983bce0d5f7fea2135a5bc466.jpg";